<template>
  <div class="searchProduct">

    <div class="search">
      <input
        type="text"
        v-model="name"
        placeholder="请输入检测项目或相关名称"
        @keydown="keydown"
      >
      <div
        class="searchBtn"
        @click="getAllProduct"
      >搜索</div>
    </div>

    <div
      class="bindingProductList"
      v-if="allProductList.length>0"
    >
      <div
        class="item"
        v-for="(item,index) in allProductList"
        @click="selectProduct(index,item.select)"
        :key="index"
      >
        <div
          class="txt"
          v-html="item.nameSpan"
        ></div>
        <img
          src="../../assets/images/updataFile/select-active.png"
          class="select"
          v-if="item.select"
        >
        <img
          v-else
          src="../../assets/images/updataFile/select.png"
          class="select"
        >
      </div>
    </div>
    <div
      class="saveDetectBoxUserData"
      @click="saveDetectBoxUserData"
      v-show="btnFlag"
      :style="{width:this.$store.state.PCFlag?'11.04rem':'',margin:'0 auto'}"
    >
      <div class="txt">确认选择</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allProductList: [],
      productIds: [],
      selectedList: [],
      name: "",
      btnFlag:true
    };
  },
  created() {
    this.barCode = this.$route.query.barCode;
    if (sessionStorage.getItem("productIds")) {
      this.productIds = JSON.parse(sessionStorage.getItem("productIds"));
      this.selectedList = JSON.parse(sessionStorage.getItem("selectedList"));
    }
    this.getAllProduct();
  },
  methods: {
    /**
     * 新增选择的产品
     */
    selectProduct(index, select) {
      let id = this.allProductList[index].id;
      let name = this.allProductList[index].name;
      if (!this.productIds.includes(this.allProductList[index].id)) {
        this.productIds.push(id);
        this.selectedList.push({
          id: id,
          name: name
        });
      } else {
        let index = this.productIds.indexOf(id);
        this.productIds.splice(index, 1);
        this.selectedList.splice(index, 1);
      }
      this.allProductList[index].select = !select;
    },
    keydown(e) {
      if (e.keyCode == 13) this.getAllProduct();
    },
    getAllProduct() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        this.$http
          .get(`/product/getAllList?name=${this.name}`)
          .then(res => {
            if (res.data.code == 200) {
              let list = res.data.data;
              if (list.length > 0) {
                list.forEach(item => {
                  if (this.productIds.includes(item.id)) {
                    item.select = true;
                  } else item.select = false;
                  item.nameSpan = item.name.replace(
                    this.name,
                    `<span style="color:#1968a8">${this.name}</span>`
                  );
                });
                this.total = 4;
                this.$store.state.closureFlag = true;
              } else {
                this.$toots("请确认产品名称正确");
              }
              this.allProductList = list;
            } else this.$toots("系统正在升级，请稍后");
          })
          .catch(err => {
            this.$toots("系统正在升级，请稍后");
          });
      }
    },
    saveDetectBoxUserData() {
      sessionStorage.setItem("productIds", JSON.stringify(this.productIds));
      sessionStorage.setItem("selectedList", JSON.stringify(this.selectedList));
      this.$router.replace({
        name: "bindingProductList",
        query: {
          barCode: this.barCode
        }
      });
    }
  },

  mounted() {
    let winh = document.body.clientHeight; // 取窗口可视范围的高度
    window.addEventListener("resize", () => {
      if (document.body.clientHeight < winh) {
        this.btnFlag = false; //隐藏按钮
      } else {
        this.btnFlag = true; //显示按钮
      }
    });
  }
};
</script>

<style lang='less' scoped>
.searchProduct {
  padding-bottom: 100px;
  .search {
    background-color: #fff;
    padding: 30px;
    display: flex;
    align-items: center;
    position: relative;
    input {
      height: 80px;
      line-height: 80px;
      padding-left: 80px;
      width: 100%;
      background: url(../../assets/images/updataFile/search-icon2.png) no-repeat
        30px;
      background-size: 32px;
      font-size: 30px;
      background-color: #f9f9f9;
      border-radius: 4px;
    }
    input::placeholder {
      color: #aaa;
      font-size: 30px;
    }
    .searchBtn {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      width: 100px;
      color: #1968a8;
      font-size: 28px;
    }
  }

  .bindingProductList {
    background-color: #fff;
    padding-left: 30px;
    padding-right: 30px;
    .item:first-child {
      border-top: 1PX solid #eee;
    }
    .item:last-child {
      border-bottom: none;
    }
    .item {
      border-bottom: 1PX solid #eee;
      font-size: 28px;
      padding-top: 30px;
      padding-bottom: 30px;
      line-height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select {
        width: 50px;
        height: 50px;
      }
    }
    .seeAll {
      font-size: 32px;
      color: #1968a8;
      line-height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 32px;
        height: 32px;
        margin-left: 10px;
        vertical-align: middle;
        padding-bottom: 6px;
      }
    }
  }
  .saveDetectBoxUserData {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
    .txt {
      background-color: #1968a8;
      font-size: 32px;
      height: 98px;
      line-height: 98px;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
